// Business results trend chart (approved HTML component: business-results-trend).
import type { ReactNode } from 'react';
import type { TrendMonth } from '../mockData.js';

export interface BusinessResultsTrendProps {
  months: TrendMonth[];
  mtdValue: string;
  mtdCaption: string;
  lines: Array<{ label: string; value: string }>;
}

export function BusinessResultsTrend({
  months,
  mtdValue,
  mtdCaption,
  lines,
}: BusinessResultsTrendProps): ReactNode {
  return (
    <section className="exec-card" data-component="business-results-trend">
      <div className="exec-head">
        <h2>Business results &amp; trend</h2>
        <small>Completed months · company net sales</small>
      </div>
      <div className="exec-body trend-wrap">
        <div>
          <div className="trend-bars">
            {months.map(m => (
              <div key={m.label} className={m.current ? 'current' : ''}>
                <strong>{m.value}</strong>
                <i style={{ height: `${m.height}px` }} />
                <small>{m.label}</small>
              </div>
            ))}
          </div>
          <p className="trend-note">
            Six completed months · April–September 2026. The selected period result is shown
            separately.
          </p>
        </div>
        <div className="business-result-panel">
          <span>MONTH-TO-DATE RESULT</span>
          <strong>{mtdValue}</strong>
          <p>{mtdCaption}</p>
          <div className="result-lines">
            {lines.map(line => (
              <div key={line.label}>
                <span>{line.label}</span>
                <b>{line.value}</b>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
